import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-history-dialog',
  templateUrl: './edit-history-dialog.component.html',
  styleUrls: ['./edit-history-dialog.component.scss'],
  standalone: false
})
export class EditHistoryDialogComponent implements OnInit {

  jobsHistoryData;

  constructor(
            @Inject(MAT_DIALOG_DATA) public editHistoryData: any,
            public dialogRef: MatDialogRef<EditHistoryDialogComponent>,
  ) { }

  ngOnInit(): void {
    //console.log("edit history data => ", this.editHistoryData);
    this.jobsHistoryData = this.editHistoryData;
  }

  jobSelected(job) {
    this.dialogRef.close(job)
  }

}
